import { render } from "./Backfilling.vue?vue&type=template&id=32be24eb"
import script from "./Backfilling.vue?vue&type=script&lang=js"
export * from "./Backfilling.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__